export enum UsersOrderByOptions {
  RANK = "rank",
  NAME = "name",
  LAST_ACTIVITY_DATE = "lastActivityDate",
}
